import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { fetchProductBySku } from '../redux/reducers/vitrineSlice';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import Modal from 'react-bootstrap/Modal';
import { useDispatch, useSelector } from 'react-redux';
//import 'react-medium-image-zoom/dist/styles.css';
import MenuPrincipal from "../components/menuPrincipal";
import { Navigation, A11y } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import LoadingOverlay from "../components/loading";
import Rodape from "../components/rodape";
import { addProductToCart } from '../redux/reducers/cartSlice';
// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/scrollbar'
import '../style/productDetails.css';


const ProductDetails = () => {
    const { sku } = useParams();
    const dispatch = useDispatch();
    const { produto, loading } = useSelector((state) => state.vitrini);
    const [selectedImage, setSelectedImage] = useState(null); // Armazenar a imagem principal selecionada
    const BASE_URL = process.env.REACT_APP_BASE_URL;
    //const [showZoom, setShowZoom] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [selectProdCar, setSelectProdCar] = useState();
    const [fadeIn, setFadeIn] = useState(false); // Classe de fade-in
    //const [zoomPosition, setZoomPosition] = useState({ x: 0, y: 0 });
    const ProductBreadcrumb = ({ produto }) => {
        return (
            <div className="product-breadcrumb mb-3">
                <Breadcrumb >
                    <Breadcrumb.Item href="/"> <i class="fa-solid fa-location-arrow pr-3"></i> Início</Breadcrumb.Item>
                    <Breadcrumb.Item href="/quero-comprar">Produtos</Breadcrumb.Item>
                    <Breadcrumb.Item active>{produto?.details?.name}</Breadcrumb.Item>
                </Breadcrumb>
            </div>
        );
    };

    useEffect(() => {
        dispatch(fetchProductBySku(sku)); // Busca os dados ao montar o componente
    }, [sku]);

    const handleThumbnailClick = (image) => {
        setFadeIn(false); // Remove classe fade-in
        setTimeout(() => {
            setSelectedImage(image.url); // Atualiza a imagem
            setFadeIn(true); // Reaplica a classe fade-in
        }, 50); // Breve atraso para reiniciar a animação
    };

    //const handleMouseEnter = () => setShowZoom(true);
    //const handleMouseLeave = () => setShowZoom(false);

    /*const handleMouseMove = (e) => {
        const { top, left, width, height } = e.currentTarget.getBoundingClientRect();
        const x = ((e.pageX - left) / width) * 100;
        const y = ((e.pageY - top) / height) * 100;
        setZoomPosition({
            x: x - 25, // Ajuste para centralizar o ponto de zoom com a posição do mouse
            y: y - 25, // Ajuste para centralizar o ponto de zoom com a posição do mouse
            show: true
        });
    };*/

    useEffect(() => {
        // Define a primeira imagem como a padrão na vitrine
        if (produto?.details?.images?.[0]) {
            setSelectedImage(produto.details.images[0].url);
        }
    }, [produto])

    const getIconClassForAttribute = (attributeName) => {
        // Lista de mapeamento de atributos para classes de ícones
        const attributeIconMap = {
            'bateria': 'fa-solid fa-battery-full',
            'câmera': 'fa-solid fa-camera',
            'memória': 'fa-solid fa-memory',
            'conectividade': 'fa-solid fa-wifi',
            'bluetooth': 'fa-solid fa-bluetooth',
            'tela': 'fa-solid fa-mobile-alt',
            'processador': 'fa-solid fa-cogs',
            'cores': 'fa-solid fa-palette',
            'carregador': 'fa-solid fa-plug',
            'carregamento': 'fa-solid fa-plug-circle-exclamation',
            'acessórios': 'fa-solid fa-box-open',
            'capacidade': 'fa-solid fa-hdd',
            'sistema operacional': 'fa-brands fa-android', // ou 'fa-brands fa-apple' para iOS
            'resolução': 'fa-solid fa-expand',
            'peso': 'fa-solid fa-weight',
            'dimensões': 'fa-solid fa-ruler-combined',
            'sensor': 'fa-solid fa-fingerprint',
            'frequência': 'fa-solid fa-signal',
            'áudio': 'fa-solid fa-headphones-alt',
            'material': 'fa-solid fa-boxes',
            'garantia': 'fa-solid fa-shield-alt',
            'dual sim': 'fa-solid fa-sim-card',
            'resistência à água': 'fa-solid fa-water',
            'garantia apple': 'fa-solid fa-shield-alt',
            
        };
        // Formata o nome do atributo para buscar no mapa (converte para minúsculas)
        const key = attributeName.toLowerCase();
        // Retorna a classe correspondente ou uma classe padrão
        return attributeIconMap[key] || 'fa-solid fa-check';
    };

    const handleAddToCart = (product) => {
        //console.log(product, 'product')
        dispatch(addProductToCart(product.details));
        setShowModal(true);
        setSelectProdCar(product.details)
    };

    useEffect(() => {
        window.scrollTo({ top: 0, left: 0, });
    }, []);

    return (
        <div>
            <MenuPrincipal />
            <div className={`box-2 loading ${loading ? 'loading-active' : ''}`}>
                <LoadingOverlay loading={loading} />
                <section className="section-spacing-2">
                    <Container>
                        <ProductBreadcrumb produto={produto} />
                        <Row className="product-details-grid">
                            <Col md={6} style={{ position: 'relative' }}>
                                <div className="vitrine-container">
                                    <img
                                        src={
                                            selectedImage
                                                ? selectedImage.startsWith("data:image") // Verifica se é base64
                                                    ? selectedImage // Base64
                                                    : `${BASE_URL}storage/${selectedImage}` // Caminho no servidor
                                                : "default-image-path" // Caminho para uma imagem padrão
                                        }
                                        alt="Produto principal"
                                        className={`vitrine-image  zoom-container ${fadeIn ? 'fade-in' : ''}`} // Aplica fade-in

                                    />
                                    <div className="tag-produto-container">
                                        {produto?.details?.stock === 0 && (
                                            <span className="badge-2 out-of-stock">
                                                Produto Esgotado
                                            </span>
                                        )}

                                        {Array.isArray(produto?.attributes) &&
                                            produto.attributes
                                                .filter((attr) => attr.attribute_name === 'Estado')
                                                .map((attr, index) => {
                                                    const values = attr?.values || [];
                                                    return (
                                                        <span key={index} className="badge-2">
                                                            <i
                                                                className="fa-solid fa-award"
                                                                style={{ fontSize: '1.2em', paddingRight: '10px' }}
                                                            ></i>
                                                            {values.map((value) => value.value).join(' - ')}
                                                        </span>
                                                    );
                                                })}
                                    </div>
                                </div>
                                <Swiper
                                    modules={[Navigation, A11y]}
                                    spaceBetween={20}
                                    slidesPerView={3}
                                    navigation
                                    pagination={{ clickable: true }}
                                >
                                    {produto?.details?.images?.map((image) => (
                                        <SwiperSlide className="thumbnail-slide">
                                            <img
                                                key={image.id}
                                                src={
                                                    image.url.startsWith("data:image") // Verifica se é base64
                                                        ? image.url // Base64
                                                        : `${BASE_URL}storage/${image.url}` // Caminho no servidor
                                                }
                                                alt={`Thumbnail ${image.id}`}
                                                className={`thumbnail photo-miniatura ${selectedImage === image.url ? 'selected' : ''}`}
                                                onClick={() => handleThumbnailClick(image)} // Atualiza a vitrine ao clicar
                                            />
                                        </SwiperSlide>
                                    ))}
                                </Swiper>
                                {/*  {showZoom && (
                                <div
                                    className="zoom-overlay"
                                    style={{
                                        backgroundImage: `url(${selectedImage.startsWith("data:image") // Verifica se é base64
                                            ? selectedImage // Base64
                                            : `${BASE_URL}storage/${selectedImage}` // Caminho no servidor
                                            })`,
                                        backgroundPosition: `${zoomPosition.x}% ${zoomPosition.y}%`,
                                        backgroundSize: '200%',
                                    }}
                                />
                            )}*/}
                            </Col>
                            <Col md={6} className='d-flex justify-content-center align-items-center config-card-cel' style={{ backgroundColor: '#ffff' }}>
                                <div className='product-info'>
                                    <div >
                                        <h2>{produto?.details?.name}</h2>
                                        <h4 className="text-primary">{Number(produto?.details?.price).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</h4>
                                        <div className="button-group">
                                            <Button onClick={() => handleAddToCart(produto)} disabled={produto?.details?.stock === 0} variant="primary">Comprar</Button>
                                        </div>
                                    </div>
                                    <div className="attribute-list-2">
                                        {produto?.attributes?.map((item, index) => {
                                            if (item.attribute_name === 'Garantia Apple' || item.attribute_name === 'Garantia' ) {
                                                return (
                                                    <div key={index} className="attribute-item-2">
                                                        <div className='d-flex justify-content-center align-items-center'>
                                                            <i style={{ color: '#ff751a', fontSize:'1.4em' }} className={getIconClassForAttribute(item.attribute_name)}></i><span className="attribute-name">{item.attribute_name}:</span>{' '}
                                                        </div>
                                                        {item?.values?.map((item2, subIndex) => (
                                                            <span key={subIndex} className="attribute-value-2">
                                                                {item2.value}
                                                            </span>
                                                        ))}
                                                    </div>
                                                );
                                            }
                                            return null; // Retorna null para os itens que não são 'Cores'
                                        })}

                                    </div>
                                    <div className="attribute-list-2">
                                        {produto?.attributes?.map((item, index) => {
                                            if (item.attribute_name === 'Cores') {
                                                return (
                                                    <div key={index} className="attribute-item-2">
                                                        <div className='d-flex justify-content-center align-items-center'>
                                                            <i style={{ color: '#ff751a' }} className={getIconClassForAttribute(item.attribute_name)}></i><span className="attribute-name">{item.attribute_name}:</span>{' '}
                                                        </div>
                                                        {item?.values?.map((item2, subIndex) => (
                                                            <span key={subIndex} className="attribute-value-2">
                                                                {item2.value}
                                                            </span>
                                                        ))}
                                                    </div>
                                                );
                                            }
                                            return null; // Retorna null para os itens que não são 'Cores'
                                        })}

                                    </div>
                                    <div className="attribute-list-2">
                                        {produto?.attributes?.map((item, index) => {
                                            if (item.attribute_name === 'Câmera') {
                                                return (
                                                    <div key={index} className="attribute-item-2">
                                                        <div className='d-flex justify-content-center align-items-center'>
                                                            <i style={{ color: '#ff751a' }} className={getIconClassForAttribute(item.attribute_name)}></i><span className="attribute-name">{item.attribute_name}:</span>{' '}
                                                        </div>
                                                        {item?.values?.map((item2, subIndex) => (
                                                            <span key={subIndex} className="attribute-value-2">
                                                                {item2.value}
                                                            </span>
                                                        ))}
                                                    </div>
                                                );
                                            }
                                            return null; // Retorna null para os itens que não são 'Cores'
                                        })}
                                    </div>
                                    {/*<div className="attribute-list-2">
                                        {produto?.attributes?.map((item, index) => {
                                            if (item.attribute_name === 'Tela') {
                                                return (
                                                    <div key={index} className="attribute-item-2">
                                                        <div className='d-flex justify-content-center align-items-center'>
                                                            <i style={{ color: '#ff751a' }} className={getIconClassForAttribute(item.attribute_name)}></i><span className="attribute-name">{item.attribute_name}:</span>{' '}
                                                        </div>
                                                        {item?.values?.map((item2, subIndex) => (
                                                            <span key={subIndex} className="attribute-value-2">
                                                                {item2.value}
                                                            </span>
                                                        ))}
                                                    </div>
                                                );
                                            }
                                            return null; // Retorna null para os itens que não são 'Cores'
                                        })}
                                    </div>*/}
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={12} className='fundo-div-produto'>
                                <div className='box-descricao'>
                                    <div dangerouslySetInnerHTML={{ __html: produto?.details?.description }} />
                                </div>
                            </Col>
                        </Row>
                        <Row className="mt-4 box-caracteristicas">
                            <h2><i style={{ color: '#ff751a' }} class="fa-solid fa-gears"></i> Ficha Técnica</h2>
                            {produto?.attributes?.map((item) => (
                                <Col md={4} sm={6} xs={12} key={item.attribute_name} className="mb-4">
                                    <Card className="attribute-card">
                                        <Card.Body>
                                            <Card.Title className="attribute-title">  <i style={{ color: '#ff751a' }} className={getIconClassForAttribute(item.attribute_name)}></i> {item.attribute_name}</Card.Title>
                                            <ul className="attribute-list">
                                                {item?.values.map((item2, index) => (
                                                    <li key={index}><i class="fa-solid fa-check"></i> {item2.value}</li>
                                                ))}
                                            </ul>
                                        </Card.Body>
                                    </Card>
                                </Col>
                            ))}
                        </Row>
                    </Container>
                </section>
            </div>
            <Modal show={showModal} onClick={() => setShowModal(false)} centered className="custom-modal">
                <Modal.Header closeButton>
                    <Modal.Title>Já adicionamos seu produto no carrinho</Modal.Title>
                </Modal.Header>
                <Modal.Body className="d-flex flex-column align-items-center">
                    <img
                        src={selectProdCar?.images[0]?.url?.startsWith("data:image")
                            ? selectProdCar?.images[0]?.url  // Se for base64
                            : `${BASE_URL}storage/${selectProdCar?.images[0]?.url}`}  // Caminho no servidor
                        alt={selectProdCar?.name}
                        className="product-image mb-3"
                        style={{ maxWidth: '150px' }}
                    />
                    <h5>{selectProdCar?.name}</h5>

                    <p className="text-muted">{Number(selectProdCar?.price).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</p>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={() => window.location.href = '/carrinho'}>
                        Ir para o Carrinho
                    </Button>
                    <Button variant="secondary" onClick={() => setShowModal(false)}>
                        Continuar Comprando
                    </Button>
                </Modal.Footer>
            </Modal>
            <Rodape />
        </div>
    );
};

export default ProductDetails;
